export default "__VITE_ASSET__CgaLPQQ7__"